import React, { useContext } from 'react';
import { compose } from 'recompose';

import withLeadConversationsContext from '../../context/LeadConversationsContext/withLeadConversationsContext';
import LeadConversationsContext from '../../context/LeadConversationsContext/LeadConversationsContext';
import EmptyView from '../../../chat/components/EmptyView';
import LeadConversationList from './components/LeadConversationList';
import LeadDetailPanel from './components/LeadDetailPanel';
import LeadClaimTakeoverModal from './components/LeadClaimTakeoverModal';

import {
  PageContainer,
  ContentContainer,
} from './styles';
import texts from './texts.json';

const SDRLeadInbox = () => {
  const { activeLeadId } = useContext(LeadConversationsContext);

  return (
    <PageContainer>
      <LeadConversationList />
      <ContentContainer>
        {activeLeadId ? (
          <LeadDetailPanel />
        ) : (
          <EmptyView content={texts.selectConversation} />
        )}
      </ContentContainer>
      <LeadClaimTakeoverModal />
    </PageContainer>
  );
};

export default compose(
  withLeadConversationsContext,
)(SDRLeadInbox);
